import { Flex, XIcon } from '@blockanalitica/ui';
// @ts-ignore
import Logo from '@/assets/logos/BA-logo-full-white.svg?react';
import { ExternalLink } from '@/components';

export default function Footer() {
  return (
    <Flex
      as="footer"
      fontSize="-1"
      color="muted"
      padding="0 1"
      display="flex"
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      gap="s">
      <Flex gap="2xs">
        <span>© 2025</span>
        <span>|</span>
        <span>Made by</span>
      </Flex>

      <ExternalLink href="https://blockanalitica.com" icon={<></>}>
        <Logo height={32} />
      </ExternalLink>

      <ExternalLink
        href="https://x.com/BlockAnalitica"
        icon={<></>}
        color="muted">
        <XIcon size={20} />
      </ExternalLink>

      <div>|</div>

      <ExternalLink
        href="https://blockanalitica.com/terms-of-service/"
        icon={<></>}
        color="muted">
        Terms of Service
      </ExternalLink>
    </Flex>
  );
}
